__webpack_require__.p = "https://stdatavisualpublic001.blob.core.windows.net/ct-documentary-2023/tatarstan/";